import { RightioWBSAPIModelsUdtUdtOfferParamsV3 } from "@src/utilities/apis/wbs/model";
import { CCNewAPIServicesOfferParam } from "../../../apis/ccm/model";

export class OfferParams_v3 implements RightioWBSAPIModelsUdtUdtOfferParamsV3 {
  constructor() {
    this.#serviceAgreementOfferId = 0;
    this.#allocationContractPeriod = 1;
    this.#serviceAgreementDurationId = 0;
    this.#allocationOrder = 1;
    this.#serviceAgreementOfferAllocationReasonId = 0;
    this.#serviceAgreementCampaignCodeId = 0;
  }

  #allocationContractPeriod: number;
  #serviceAgreementDurationId: number;
  #serviceAgreementOfferId: number;
  #allocationOrder: number;
  #serviceAgreementOfferAllocationReasonId: number;
  #serviceAgreementCampaignCodeId: number | null;

  toObject(): any {
    return {
      _allocationContractPeriod: this.#allocationContractPeriod,
      _serviceAgreementDurationId: this.#serviceAgreementDurationId,
      _serviceAgreementOfferId: this.#serviceAgreementOfferId,
      _allocationOrder: this.#allocationOrder,
      _serviceAgreementOfferAllocationReasonId: this.#serviceAgreementOfferAllocationReasonId,
      _serviceAgreementCampaignCodeId: this.#serviceAgreementCampaignCodeId,
    };
  }

  toRequest(): CCNewAPIServicesOfferParam[] {
    return [{
      allocationContractPeriod: this.#allocationContractPeriod,
      serviceAgreementDurationId: this.#serviceAgreementDurationId,
      serviceAgreementOfferId: this.#serviceAgreementOfferId,
      allocationOrder: this.#allocationOrder,
      serviceAgreementOfferAllocationReasonId: this.#serviceAgreementOfferAllocationReasonId,
      serviceAgreementCampaignCodeId: this.#serviceAgreementCampaignCodeId,
    }];
  }

  public get serviceAgreementOfferId(): number {
    return this.#serviceAgreementOfferId;
  }

  public set serviceAgreementOfferId(serviceAgreementOfferId: number) {
    this.#serviceAgreementOfferId = serviceAgreementOfferId;
  }

  public get allocationContractPeriod(): number {
    return this.#allocationContractPeriod;
  }

  public set allocationContractPeriod(allocationContractPeriod: number) {
    this.#allocationContractPeriod = allocationContractPeriod;
  }

  public get serviceAgreementDurationId(): number {
    return this.#serviceAgreementDurationId;
  }

  public set serviceAgreementDurationId(serviceAgreementDurationId: number) {
    this.#serviceAgreementDurationId = serviceAgreementDurationId;
  }

  public get allocationOrder(): number {
    return this.#allocationOrder;
  }

  public set allocationOrder(allocationOrder: number) {
    this.#allocationOrder = allocationOrder;
  }

  public get serviceAgreementOfferAllocationReasonId(): number {
    return this.#serviceAgreementOfferAllocationReasonId;
  }

  public set serviceAgreementOfferAllocationReasonId(serviceAgreementOfferAllocationReasonId: number) {
    this.#serviceAgreementOfferAllocationReasonId = serviceAgreementOfferAllocationReasonId;
  }

  public get serviceAgreementCampaignCodeId(): number | null {
    return this.#serviceAgreementCampaignCodeId;
  }

  public set serviceAgreementCampaignCodeId(serviceAgreementCampaignCodeId: number | null) {
    this.#serviceAgreementCampaignCodeId = serviceAgreementCampaignCodeId;
  }
}
